import React from 'react'
import Header from '../../componentes/Header'
import { Contact } from '../../componentes/PaginaInicial/Conteudo/Contact'
import Home from '../../componentes/PaginaInicial/Conteudo/Home'
import NavLateral from '../../componentes/PaginaInicial/Conteudo/NavLateral'
import Projetos from '../../componentes/PaginaInicial/Conteudo/Projetos'
import Scroll from '../../componentes/PaginaInicial/Conteudo/Scroll'
import Sobre from '../../componentes/PaginaInicial/Conteudo/Sobre'
import { SkillUser } from '../../componentes/PaginaInicial/Skill'

export const LandingPage = () => {
  return (
    <div>
        <Header />
        <Home />
        <Sobre />
        <Projetos />
        <SkillUser />
        <Contact />
        <NavLateral />
        <Scroll />
    </div>
  )
}
